import { StoreInterface } from '../../../../store/types';
import { useSelector } from 'react-redux';
import { REDUX_STORE_SLICES } from '../../../../services/exports/Constants';
import { useParams } from 'react-router-dom';

export function useDefaultSlug(): { slug: string; hasCompany: boolean } {
  const { slug } = useParams();
  const paramsSlug = slug !== '404' && slug;
  const selectedCompanySlug = useSelector((s: StoreInterface) => s[REDUX_STORE_SLICES.INITIAL_DATA]?.company?.slug);
  const firstCompanySlug = useSelector(
    (s: StoreInterface) => s[REDUX_STORE_SLICES.INITIAL_DATA].franchise?.companies?.[0]?.slug,
  );

  return {
    slug: selectedCompanySlug ?? firstCompanySlug ?? paramsSlug,
    hasCompany: !!selectedCompanySlug,
  };
}
